import React from 'react'
import { Home2, About2, Services2, Sections2, Doctors2, Blog2, Company, Contact } from '../Components'

const Home = () => {
    return (
        <div>
            <Home2/>
            <About2/>
            <Services2/>
            <Sections2/>
            <Doctors2/>
            <Blog2/>
            <Company/>
            <Contact/>
        </div>
    )
}

export default Home